import { IPart, IPartManufacturer } from 'parts/types';

// Bridges search-result IPart → IPartManufacturer so the Manufacturer tab can render
// the name immediately, before useGetPart returns the full manufacturer with website,
// phone, email, and logo.
export const partToManufacturer = (part: IPart): IPartManufacturer | null =>
  part.manufacturerId != null
    ? {
        id: part.manufacturerId,
        name: part.manufacturerName,
        urlName: part.manufacturerUrlName,
      }
    : null;
